@if(!isLoading()) {
    @if(categories().length > 0){
        <h5 class="fw-semibold">All Categories</h5>
    }
    <div>
        <ul class="list-unstyled list-inline fs-6 inter meta">
            @for (obj of categories(); track obj.slug) {
                <li class="d-inline-block">
                    <a [routerLink]="['/categories', obj.slug, 3, 1]"  class="text-decoration-none border inter fs-7 border-gray rounded-4 py-1 px-2 text-dark me-3 mb-3 d-inline-block">{{obj.category}}</a>
                </li>
            }
        </ul>
    </div>
    @if(tags().length > 0){
        <h5 class="fw-semibold">All Tags</h5>
    }
    <div>
        <ul class="list-unstyled list-inline fs-6 inter meta">
            @for (obj of tags(); track obj.slug) {
                <li class="d-inline-block">
                    <a [routerLink]="['/tags', obj.slug, 3, 1]"  class="text-decoration-none border inter fs-7 border-gray rounded-4 py-1 px-2 text-dark me-3 mb-3 d-inline-block">{{obj.tag}}</a>
                </li>
            }
        </ul>
    </div>
}